<div class="FormsPoi">
    @if (isSaving || isLoading) {
        <app-pg-loading [isOverlay]="true" [isLarge]="true"></app-pg-loading>
    }
    @if (!isLoading) {
        <div>
            <app-forms-main [isSupplier]="true" [notFound]="notFound" [inModal]="inModal" [importData]="importData" [formId]="formId" [formFlow]="formFlow" [flowState]="flowState" (flowStateChange)="onFlowStateChange($event)" [returnUrl]="returnUrl" [viewOnly]="viewOnly" (valuesChange)="onValuesChange($event)" (saveData)="onSaveData($event)" (resetForm)="onResetForm()" (cancelEdit)="onCancelEdit()"></app-forms-main>
        </div>
    }
</div>
